import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import NoPermissions from "../../../Layouts/NoPermissions";
import { toast } from "react-toastify";

const DeleteSessions = (props) => {
    const [schools, setSchools] = useState([])
    const [operators, setOperators] = useState([])
    const [selectedInstance, setSelectedInstance] = useState(0)
    const [selectedOperator, setSelectedOperator] = useState(0)
    const [selectedSchool, setSelectedSchool] = useState(0)
    const [selectedType, setSelectedType] = useState(0)
    const [selectedUser, setSelectedUser] = useState("")
    const getOperators = () => {
        var config = {
            method: "get",
            url: process.env.REACT_APP_API_URL + "Operators/GetOperators",
            headers: {
                "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
        };

        api(config)
            .then(function (response) {
                if (response.status == 200) {
                    setOperators(response.data);
                }
            })
    }
    const getSchools = () => {
        var config = {
            method: "Get",
            url: process.env.REACT_APP_API_URL + "Schools/GetSchools/",
            headers: {
                "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
        };

        api(config)
            .then(function (response) {
                if (response.data.statusCode == 200) {
                    setSchools(response.data.content);
                }
            })
    }

    const deletedSessions = () => {
        var data = {
            InstanceId: selectedInstance == null ? null : parseInt(selectedInstance),
            UserId:selectedUser,
            OperatorId: selectedOperator,
            SchoolId: selectedSchool,
            Type: selectedType
        }
        var config = {
            method: "patch",
            url: process.env.REACT_APP_API_URL + "UserSessions/DeleteUsersSessions",
            headers: {
                "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            data: data
        };

        api(config)
            .then(function (response) {
                if (response.data.statusCode === 200) {
                    toast.success("Session Deleted");
                    setSelectedInstance(0);
                    setSelectedOperator(0);
                    setSelectedSchool(0);
                    setSelectedUser("")
                    setSelectedType(0);
                }
            })
    }
    useEffect(() => {
        getOperators();
        getSchools();
    },[])
    return (
        <>
            {props.userPermissions.deleteSessions ? (
                <>
                    <div className="container-fluid mt-30">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Session Control</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <label>Instance</label>
                                                <select className="form-control form-control-sm" onChange={(e) => setSelectedInstance(e.target.value)} value={selectedInstance}>
                                                    <option value={0}>-- Select Instance --</option>
                                                    <option value={1}>CTS</option>
                                                    <option value={2}>CS1</option>
                                                    <option value={3}>CS2</option>
                                                    <option value={4}>CS3</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr></hr>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-2">
                                                <label>User Id</label>
                                                <input className="form-control form-control-sm" onChange={(e) => { setSelectedUser(e.target.value); setSelectedOperator(0); setSelectedSchool(0) }}/>
                                            </div>
                                            <div className="col-md-2">
                                                <h6 style={{ margin: 0 }}>&nbsp;</h6>
                                                <button className="btn btn-sm btn-danger" onClick={() => deletedSessions()}>
                                                    Delete Session
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                            <hr></hr>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-2">
                                                <label>Type</label>
                                                <select className="form-control form-control-sm" onChange={(e) => setSelectedType(e.target.value)} value={selectedType}>
                                                    <option value={0}>-- Select Type --</option>
                                                    <option value={1}>Students</option>
                                                    <option value={2}>Teachers</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">
                                                <label>Operators</label>
                                                <select className="form-control form-control-sm" onChange={(e) => setSelectedOperator(e.target.value)} disabled={selectedUser != ""} value={selectedOperator}>
                                                    <option value={0}>-- Select Operator --</option>
                                                    {operators.map((o) => 
                                                        <option value={o.operatorId}>{o.operatorName}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <label>Schools</label>
                                                <select className="form-control form-control-sm" onChange={(e) => setSelectedSchool(e.target.value)} disabled={selectedUser != ""} value={selectedSchool}>
                                                    <option value={0}>-- Select School --</option>
                                                    {schools.filter(i => i.operatorId == selectedOperator).map((o) =>
                                                        <option value={o.schoolId}>{o.schoolName}</option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <h6 style={{ margin: 0 }}>&nbsp;</h6>
                                                <button className="btn btn-sm btn-danger" onClick={() => deletedSessions()}>
                                                    Delete Session
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <NoPermissions />
            )}
        </>
    );
}

export default DeleteSessions;